import Claim from './claim';

class FlavorMaxDiff extends Claim {
  constructor(projectData, priceData, size) {
    super(projectData, priceData, size);
  }
}

export default FlavorMaxDiff;
